import {useQuery} from '@tanstack/react-query'
import {getAppOrigin} from '@salesforce/pwa-kit-react-sdk/utils/url'
import {MRT_API_BASEPATH} from '../../ssr/constants'
/**
 * Hook to validate the vat from the vat api
 */

const useGetVatValidation = (vatData) => {
    const appOrigin = getAppOrigin()
    return useQuery(
        ['vatValidationApiCall', vatData],
        async () => {
            const res = await fetch(`${appOrigin}${MRT_API_BASEPATH}/vat-validation`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({vatData}),
            })
            return res.json()
        },
        {
            enabled: !!vatData,
        },
    )
}

export default useGetVatValidation
